// extracted by mini-css-extract-plugin
export default {"buttons":"_1zng2fdAB53gkyliBvu0Pi"};